import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn, } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern, datePickerMinDate, convertToNgbDate, reported_as_list, mobilePatternIndian, } from '../../shared/constants';
import { NgSelectModule } from '@ng-select/ng-select';
import { timer } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, filter, take, takeUntil, switchMap, catchError, } from 'rxjs/operators';
import { inject, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavbarComponent } from '../../navbar/navbar.component';
import moment from 'moment';

@Component({
	selector: 'app-book-appointment',
	templateUrl: './book-appointment.component.html',
	styleUrl: './book-appointment.component.scss',
})


export class BookAppointmentComponent implements OnInit, OnDestroy, AfterViewInit {
	moduleForm: FormGroup = this.formBuilder.group({
		id: [null],
		case_id: [null],
		candidateId: [null],
		start_date: [new Date(), [Validators.required, noWhitespaceInRequiredValidator]],
		f_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		m_name: null,
		l_name: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		gender: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		dob: [null],
		age: [null],
		address: null,
		nationality: null,
		email: [null, [Validators.pattern(emailPattern)]],
		country_code: [null, [Validators.required]],
		tel_no: [null, [Validators.required, Validators.pattern(mobilePatternIndian)]],
		crew_id: [null],
		company: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		vessel: [null, [Validators.required, noWhitespaceInRequiredValidator]],
		rank: [null],
		upcoming_arrival: [false]
	});
	showLoader: boolean = false;
	pageLoading: boolean = false;
	@Input() uId: any = null;
	@Input() mailIds: any = null;
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	countryCodes: any[] = [];
	countryList: any[] = [];
	stateList: any[] = [];
	cityList: any[] = [];
	vesselList: any[] = [];
	rankList: any[] = [];
	companyList: any[] = [];
	statusList: any[] = [];
	categoryList: any[] = [];
	departmentList: any[] = [];
	caseCategoryList: any[] = [];
	case_id_id: any;
	minDate = datePickerMinDate;
	minStartDate = datePickerMinDate;
	maxDate = convertToNgbDate(new Date());

	searchControl = new FormControl(null);
	formCtrlSub!: Subscription;
	fetchCaseIdDetailsLoader = false;
	detailsFromCaseId: any = null;
	mailList: any[] = [];
	mailLoading = false;
	pagetitle = "Create Appointment";

	constructor(private toastr: ToastrService, private apiService: ApiService, public formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	get f() {
		return this.moduleForm.controls;
	}

	ngOnInit(): void {
		this.getCaseCategory();
		this.getRank();
		this.getCountryCodes();
		this.getCompany();
		this.getallDepartment();
		this.getallCategory();
		this.getCountryList();
		if (this.uId) {
			this.pagetitle = "Edit Appointment";
			this.f.start_date.disable()
			this.getDetails();
		} else {
			this.minStartDate = convertToNgbDate(new Date());
		}
		if (this.mailIds) {
			const mailIds = this.mailIds.split("-");
			this.getMails(mailIds);
		}
	}

	ngAfterViewInit(): void {
		this.formCtrlSub = this.searchControl.valueChanges.pipe(debounceTime(1000)).subscribe(newValue => {
			this.getHCCaseDetails();
		});
	}

	ngOnDestroy(): void {
		try {
			this.formCtrlSub.unsubscribe();
		} catch (error) { }
	}

	calculateAge() {
		const dob = this.f.dob.value;
		if (dob) {
			this.f.age.setValue(moment().diff(moment(dob), 'years'));
		} else {
			this.f.age.setValue(null);
		}
	}

	getMails(mailIds: any[]) {
		this.mailLoading = true;
		this.apiService.getMultipleMail(mailIds).subscribe({
			next: (response: any) => {
				this.mailLoading = false;
				this.mailList = response
			}, error: (error) => {
				this.mailLoading = false;
				this.mailList = [];
				this.toastr.error("Something went wrong.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getVessel() {
		if (this.f.company.value) {
			this.apiService.getVessel({ company: this.f.company.value }).subscribe({
				next: (data: any) => {
					this.vesselList = data.data;
				}, error: (error) => {
					this.vesselList = [];
				},
			});
		} else {
			this.vesselList = [];
		}
	}

	getCaseCategory() {
		this.apiService.getCaseCategory().subscribe({
			next: (data: any) => {
				this.caseCategoryList = data;
			}, error: (error) => {
				this.caseCategoryList = [];
			},
		});
	}

	getRank() {
		this.apiService.getRank({}).subscribe({
			next: (data: any) => {
				this.rankList = data.data;
			}, error: (error) => {
				this.rankList = [];
			},
		});
	}

	getCompany() {
		this.apiService.getCompany({}).subscribe({
			next: (data: any) => {
				this.companyList = data.data;
			}, error: (error) => {
				this.companyList = [];
			},
		});
	}

	getallCategory() {
		this.apiService.getallCategory().subscribe({
			next: (data: any) => {
				this.categoryList = data.data;
			}, error: (error) => {
				this.categoryList = [];
			},
		});
	}

	getallDepartment() {
		this.apiService.getallDepartments().subscribe({
			next: (data: any) => {
				this.departmentList = data.data;
			}, error: (error) => {
				this.departmentList = [];
			},
		});
	}

	getCountryCodes() {
		this.apiService.countryCodes().subscribe({
			next: (data: any) => {
				data.map((c: any) => {
					c.display = c.dial_code + ' ' + '(' + c.name + ')';
					return c;
				});
				this.countryCodes = data;
			}, error: (error) => {
				this.countryCodes = [];
			},
		});
	}

	getCountryList() {
		this.apiService.countryList().subscribe({
			next: (data: any) => {
				this.countryList = data.data;
			},
			error: (error) => {
				this.countryList = [];
			},
		});
	}

	clearForm() {
		this.moduleForm.reset();
		this.cleared.emit();
	}

	getDetails() {
		this.pageLoading = true;
		this.apiService.getCase({ id: this.uId }).subscribe({
			next: (data: any) => {
				let obj = data.data;
				this.moduleForm.setValue({
					id: obj.id,
					candidateId: obj.candidate.id,
					case_id: obj.case_id,
					f_name: obj.candidate.f_name,
					m_name: obj.candidate.m_name,
					l_name: obj.candidate.l_name,
					address: obj.candidate.address,
					country_code: obj.candidate.country_code,
					tel_no: obj.candidate.tel_no,
					email: obj.candidate.email,
					nationality: obj.candidate.nationality_id,
					gender: obj.candidate.gender,
					start_date: this.apiService.getDateFromDateString(obj.start_date),
					dob: this.apiService.getDateFromDateString(obj.candidate.dob),
					age: obj.candidate.age,
					crew_id: obj.crew_id,
					vessel: obj.vessel ? obj.vessel.id : null,
					rank: obj.rank ? obj.rank.rank_id : null,
					company: obj.company ? obj.company.id : null,
					upcoming_arrival: obj.upcoming_arrival
				});
				this.getVessel();
			}, error: (error) => {
				if (error.status == 401) {
					return;
				}
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true,
				});
			},
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach((key) => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) { }
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info('Please check required fields', 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true,
			});
			return;
		}
		let candidate: any = {
			id: this.f.candidateId.value || '',
			f_name: this.f.f_name.value,
			m_name: this.f.m_name.value,
			l_name: this.f.l_name.value,
			email: this.f.email.value,
			gender: this.f.gender.value,
			nationality_id: this.f.nationality.value,
			dob: this.apiService.getDateStringFromDate(this.f.dob.value),
			age: this.f.age.value,
			address: this.f.address.value,
			country_code: this.f.country_code.value,
			tel_no: this.f.tel_no.value,
		};
		let data: any = {
			id: this.f.id.value || '',
			candidate,
			crew_id: this.f.crew_id.value || null,
			start_date: this.apiService.getDateStringFromDate(this.f.start_date?.value) || null,
			vessel: this.f.vessel.value,
			rank: this.f.rank.value,
			upcoming_arrival: this.f.upcoming_arrival.value,
			company: this.f.company.value
		};
		if (!this.f.id.value && this.detailsFromCaseId) {
			data["symptoms"] = this.detailsFromCaseId?.symptoms;
			data["sub_symptoms"] = this.detailsFromCaseId?.subsymptoms;
			data["medications_onboard"] = this.detailsFromCaseId?.medicines;
			data["initial_complaints"] = this.detailsFromCaseId?.initialDiagnosis;

			data["sign_off_by"] = this.detailsFromCaseId?.signoff_by;
			data["sign_off_date"] = this.detailsFromCaseId?.signoff_date;
			data["assigned_dr_rma"] = this.detailsFromCaseId?.dr_name;
			data["port_visit_done"] = this.detailsFromCaseId?.port_visit;
			data["medical_summary"] = this.detailsFromCaseId?.medical_summary;
			data["reported_as"] = this.detailsFromCaseId?.reported_as;
		}
		if (this.f.case_id.value) {
			data["case_id"] = this.f.case_id.value;
		}
		if (this.mailList.length && !this.f.id.value) {
			data["mailIds"] = this.mailList.map((mail) => mail.id);
		}
		this.showLoader = true;
		this.apiService.createUpdateCase(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true,
				});
				this.created.emit(data);
				/* this.clearForm(); */
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) {
					return;
				}
				let errorMsg = 'Something went wrong.';
				if (error.status == 400) {
					errorMsg = error.error;
					if (typeof errorMsg == 'object') {
						for (const [key, value] of Object.entries(errorMsg)) {
							let val: any = value;
							if (val[0] == 'This field must be unique.') {
								val[0] = 'Already exists';
							}
							if (this.moduleForm.controls[key]) {
								this.moduleForm.controls[key].setErrors({ incorrect: true });
								this.customError[key] = val[0];
								let selector = '#' + key;
								try {
									$('html, body').animate(
										{
											scrollTop: $(selector).offset().top - 60 + 'px',
										},
										'fast'
									);
								} catch (error) { }
								$(selector).focus();
							} else {
								this.toastr.error(key + ':' + val[0], 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true,
								});
							}
						}
						return;
					} else {
						errorMsg = error.error;
					}
				}
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true,
				});
			},
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	openCaseIdModal() {
		this.searchControl.setValue(null);
		this.detailsFromCaseId = null;
		$("#caseIdModal").modal("show");
	}

	closeCaseIdModal() {
		$("#caseIdModal").modal("hide");
		this.searchControl.setValue(null);
		this.detailsFromCaseId = null;
	}

	getHCCaseDetails() {
		if (this.searchControl.value) {
			this.fetchCaseIdDetailsLoader = true;
			this.apiService.fetchHcData({ caseId: this.searchControl.value }).subscribe({
				next: (data: any) => {
					this.fetchCaseIdDetailsLoader = false;
					if (data != "Please check all the required parameters.") {
						const detailsFromCaseId: any = data;
						if (typeof detailsFromCaseId.medicines == "string") {
							try {
								detailsFromCaseId.medicines = detailsFromCaseId.medicines ? JSON.parse(detailsFromCaseId.medicines) : [];
								if (detailsFromCaseId.medicines == null) {
									detailsFromCaseId.medicines = [];
								}
							} catch (error) {
								detailsFromCaseId.medicines = [];
							}
						} else {
							try {
								detailsFromCaseId.medicines = detailsFromCaseId.medicines ? JSON.parse(JSON.stringify(detailsFromCaseId.medicines)) : [];
								if (detailsFromCaseId.medicines == null) {
									detailsFromCaseId.medicines = [];
								}
							} catch (error) {
								detailsFromCaseId.medicines = [];
							}
						}
						for (let i = 0; i < detailsFromCaseId.medicines.length; i++) {
							detailsFromCaseId.medicines[i].isSaved = true;
							try {
								if (detailsFromCaseId.medicines[i].medDate) {
									detailsFromCaseId.medicines[i].medDate = detailsFromCaseId.medicines[i].medDate.split("T")[0];
									detailsFromCaseId.medicines[i].medDate = detailsFromCaseId.medicines[i].medDate.replace(/-/g, "/");
								}
								if (!isNaN(detailsFromCaseId.medicines[i].noOfDays) && detailsFromCaseId.medicines[i].medDate) {
									let medDate: any = new Date(detailsFromCaseId.medicines[i].medDate);
									medDate.setHours(0, 0, 0, 0);
									let noOfDays: any = parseInt(detailsFromCaseId.medicines[i].noOfDays);
									const today: any = new Date();
									today.setHours(0, 0, 0, 0);
									const diffTime: any = Math.abs(today - medDate);
									const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
									if (diffDays >= noOfDays && detailsFromCaseId.medicines[i].status == "Started") {
										detailsFromCaseId.medicines[i].status = "Completed";
									}
								}
							} catch (error) { }
						}
						try {
							detailsFromCaseId.symptoms = detailsFromCaseId.symptoms !== null ? detailsFromCaseId.symptoms : [];
						} catch (error) {
							detailsFromCaseId.symptoms = [];
						}
						try {
							detailsFromCaseId.subsymptoms = detailsFromCaseId.subsymptoms !== null ? detailsFromCaseId.subsymptoms : [];
						} catch (error) {
							detailsFromCaseId.subsymptoms = [];
						}
						let reported_as = "";
						if (detailsFromCaseId.symptoms) {
							try {
								const len = detailsFromCaseId.symptoms.length;
								for (let i = 0; i < len; i++) {
									const len1 = reported_as_list.length;
									for (let j = 0; j < len1; j++) {
										if (detailsFromCaseId.symptoms[i].toLowerCase() == reported_as_list[j]) {
											reported_as = detailsFromCaseId.symptoms[i];
										}
									}
								}
							} catch (error) { }
						}
						detailsFromCaseId.reported_as = reported_as;
						let subsymptoms: any[] = [];
						if (detailsFromCaseId.subsymptoms) {
							try {
								Object.entries(detailsFromCaseId.subsymptoms).forEach(([key, value]) => {
									subsymptoms.push(value);
								});
							} catch (error) { }
						}
						detailsFromCaseId.subsymptoms = subsymptoms;
						this.detailsFromCaseId = detailsFromCaseId;
					}
				}, error: (error: any) => {
					this.fetchCaseIdDetailsLoader = false;
					this.detailsFromCaseId = null;
					if (error.status == 401) { return }
					if (error.status == 400) {
						this.toastr.warning("Appointment with this Case-Id already exists.", 'Warning', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					} else if (error.status == 500) {
						this.toastr.warning(error.error, 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					} else {
						this.toastr.error("No details found.", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				}
			});
		}
	}

	getFrequencyText(obj: any) {
		let textArr: any = [];
		if (obj.morning) {
			textArr.push("Morning");
		}
		if (obj.afternoon) {
			textArr.push("Afternoon");
		}
		if (obj.evening) {
			textArr.push("Evening");
		}
		if (obj.sos) {
			textArr.push("SOS");
		}
		return textArr.join(", ");
	}

	useCaseDetails() {
		if (!this.detailsFromCaseId) {
			this.toastr.error("No case details.", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.f.f_name.setValue(this.detailsFromCaseId.f_name);
		this.f.l_name.setValue(this.detailsFromCaseId.l_name);
		this.f.gender.setValue(this.detailsFromCaseId.gender);
		this.f.crew_id.setValue(this.detailsFromCaseId.crew_id);
		try {
			var date = this.detailsFromCaseId.dob;
			if (date != null && date != "") {
				var dateArr = date.split("-");
				date = new Date(dateArr.join("/"));
				this.f.dob.setValue(date);
				this.calculateAge();
			} else {
				this.f.dob.setValue(null);
			}
		} catch (error) { }
		this.f.email.setValue(this.detailsFromCaseId.email);

		if (this.detailsFromCaseId.nationality) {
			let len = this.countryList.length;
			for (let i = 0; i < len; i++) {
				try {
					if (this.countryList[i].nationality.toLowerCase() == this.detailsFromCaseId.nationality.toLowerCase()) {
						this.f.nationality.setValue(this.countryList[i].id);
						break;
					}
				} catch (error) { }
			}
		}
		if (this.detailsFromCaseId.company) {
			let len = this.companyList.length;
			for (let i = 0; i < len; i++) {
				try {
					if (this.companyList[i].com_name.toLowerCase() == this.detailsFromCaseId.company.toLowerCase()) {
						this.f.company.setValue(this.companyList[i].id);
						if (this.detailsFromCaseId.vessel) {
							this.bindVesselFromCaseId();
						}
						break;
					}
				} catch (error) { }
			}
		}
		if (this.detailsFromCaseId.rank) {
			let len = this.rankList.length;
			for (let i = 0; i < len; i++) {
				try {
					if (this.rankList[i].rank.toLowerCase() == this.detailsFromCaseId.rank.toLowerCase()) {
						this.f.rank.setValue(this.rankList[i].rank_id);
						break;
					}
				} catch (error) { }
			}
		}
		this.f.case_id.setValue(this.detailsFromCaseId.caseId);
		$("#caseIdModal").modal("hide");
		this.moduleForm.markAsDirty();
	}

	bindVesselFromCaseId() {
		if (this.f.company.value) {
			this.apiService.getVessel({ company: this.f.company.value }).subscribe({
				next: (data: any) => {
					this.vesselList = data.data;
					let len = this.vesselList.length;
					for (let i = 0; i < len; i++) {
						try {
							if (this.vesselList[i].vessel_name.toLowerCase() == this.detailsFromCaseId.vessel.toLowerCase()) {
								this.f.vessel.setValue(this.vesselList[i].id);
								break;
							}
						} catch (error) { }
					}
				}, error: (error) => {
					this.vesselList = [];
				}
			});
		} else {
			this.vesselList = [];
		}
	}
}
